import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  Head: {
    A_VocTyp: "",
    A_VocNo: "",
    A_VocDt: new Date(),
    L_DropID: "",
    L_BaseQty: "",
    TotalPickedQty: "",
    CompletionPercentage: "",
    Status: "ENTER",
    SegregationMethod: "",
    LocName: "",
    Location: "",
    NumberID: "",
  },

  Item: {
    L_Loc: "",
    LocName: "",
    TotalBaseQty: "",
    TotalPickedQty: "",
    BalanceQty: "",
    L_DropID: "",
    ItmName: "",
    ItmCd: "",
    Status: "ENTER",
    A_SegregationMethod: "",
    UnitId: "",
  },
  Barcode: "",
};

const SliceSegregation = createSlice({
  name: "SliceSegregation",
  initialState: { value: initialState },

  reducers: {
    Segregation_Init: (state) => {
      state.value = initialState;
    },
    Head_Set: (state, action) => {
      state.value.Head = action.payload;
    },
    Item_Set: (state, action) => {
      state.value.Item = action.payload;
    },
    Drop_Id_Set: (state, action) => {
      state.value.Item.L_DropID = action.payload;
    },
    Barcode_Set: (state, action) => {
      state.value.Barcode = action.payload;
    },
  },
});

export const {
  Segregation_Init,
  Head_Set,
  Item_Set,
  Drop_Id_Set,
  Barcode_Set,
} = SliceSegregation.actions;
export default SliceSegregation.reducer;
